import React, { useEffect, useCallback, useMemo, useState } from "react"
import { InputModel } from "../../../../types/control"
import { useLocalization } from "../../../../hooks/localization"
import { useParams } from "react-router-dom"
import { ColumnModel, SettingsList } from "../../../../components/Settings/SettingsList"
import { useSetSelector } from "../../../../hooks/set-selector"
import { useSelector } from "react-redux"
import { PasswordContainer } from "../../../../components/PasswordContainer"
import { SettingsPageContainer } from "../../../../components/Settings/SettingsPageContainer"

const keyExtractor = (item: InputModel) => item.id
export const InputListScreen = function KeypadListScreen() {
  const { t } = useLocalization()
  const bridgeDeviceSet = useSetSelector(state => state.control.bridgeDeviceList)
  const params = useParams<{ device_id: string }>()
  const inputList = useSelector(state => state.control.inputList).filter(
    input => input?.bridge_device_id === params.device_id
  )
  const inputTypeSet = useSetSelector(state => state.control.inputTypeList)
  const [selectedInput, setSelectedInput] = useState<InputModel>(null)
  useEffect(() => console.log(selectedInput), [selectedInput])

  const buttons = useMemo(
    () => [
      {
        text: t("edit"),
        url: `/settings/keypad/${params.device_id}/input/${selectedInput ? selectedInput.id : ""}/`,
        className: "orange",
        hidden: !selectedInput
      }
    ],
    [t, selectedInput, params.device_id]
  )

  const displayNameExtractor = useCallback(
    (item: InputModel, column: ColumnModel) => {
      if (column.key === "bridge_device_id") {
        return bridgeDeviceSet[item.bridge_device_id]?.name
      }
      if (column.key === "type_id") {
        return inputTypeSet[item.type_id]?.name
      }
      if (column.key === "pin") {
        return item?.keypad_settings?.pin
      }
      return item[column.key]?.toString() || "-"
    },
    [bridgeDeviceSet, inputTypeSet]
  )

  const columns = useMemo<ColumnModel[]>(
    () => [
      { length: 3, name: t("input_name"), key: "name" },
      { length: 2, name: t("device"), key: "bridge_device_id" },
      { length: 2, name: t("type"), key: "type_id" },
      { length: 1, name: "PIN", key: "pin" }
    ], [t]
  )
  return (
    <PasswordContainer requiredRole="user" isFullscreen={true}>
      <SettingsPageContainer
        buttons={buttons}
        className="camera-list-page"
        backUrl={'/settings/keypad/'}
        searchable={true}
      >
        <SettingsList
          columns={columns}
          items={inputList}
          listType="keypadInputList"
          displayNameExtractor={displayNameExtractor}
          keyExtractor={keyExtractor}
          selectedItem={selectedInput}
          onItemSelected={setSelectedInput}
        />
      </SettingsPageContainer>
    </PasswordContainer>
  )
}